export const messages = {
    "wr-dashboard.search.input.hint": "Carian",
    "wr-dashboard.search.label.breadcrumb": "Keputusan carian",
    "wr-dashboard.search.message.empty": "Item tidak sepadan dengan carian anda",
    "wr-dashboard.side-bar.selected.title:plural": "{count} item dipilih | {count} item dipilih",
    "wr-dashboard.side-bar.backup-type.disk": "Cakera",
    "wr-dashboard.side-bar.backup-type.file": "Fail",
    "wr-dashboard.side-bar.backup-type.notarized": "Folder dan fail diperakui oleh notari",
    "wr-dashboard.side-bar.backup-type.exchange": "Aplikasi - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Aplikasi - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Aplikasi - System state",
    "wr-dashboard.side-bar.backup-type.application": "Aplikasi",
    "wr-dashboard.backups-table.column.name": "Nama",
    "wr-dashboard.backups-table.column.size": "Saiz",
    "wr-dashboard.backups-table.column.version": "Versi terakhir",
    "wr-dashboard.backups-table.action.delete": "Hapus",
    "wr-dashboard.backups-table.message.no-backups": "Tiada sandaran lagi dalam Awan",
    "wr-dashboard.backups-sidebar.label.size": "Saiz",
    "wr-dashboard.backups-sidebar.label.type": "Jenis",
    "wr-dashboard.backups-sidebar.label.version": "Versi terakhir",
    "wr-dashboard.backups-sidebar.label.created": "Diciptakan",
    "wr-dashboard.backups-sidebar.label.machine": "Mesin",
    "wr-dashboard.backups-sidebar.label.owner": "Pemilik",
    "wr-dashboard.content-table.column.name": "Nama",
    "wr-dashboard.content-table.column.versions": "Versi",
    "wr-dashboard.content-table.column.volumes": "Isipadu",
    "wr-dashboard.content-table.column.path": "Laluan",
    "wr-dashboard.content-table.column.size": "Saiz",
    "wr-dashboard.content-table.column.version": "Versi terakhir",
    "wr-dashboard.content-table.action.notary-verify": "Sahkan",
    "wr-dashboard.content-table.action.notary-get-crt": "Dapatkan sijil",
    "wr-dashboard.content-table.action.asign": "Hantar untuk tandatangan",
    "wr-dashboard.content-table.action.versions": "Versi",
    "wr-dashboard.content-table.action.restore": "Muat turun",
    "wr-dashboard.content-table.label.size": "Saiz",
    "wr-dashboard.content-table.label.created": "Diciptakan",
    "wr-dashboard.content-table.label.modified": "Diubah suai",
    "wr-dashboard.content-table.message.empty-folder": "Folder ini kosong",
    "wr-dashboard.password-dialog-box.title.backup": "Sandaran disulitkan",
    "wr-dashboard.password-dialog-box.title.archive": "Arkib disulitkan",
    "wr-dashboard.password-dialog-box.message.backup": "Sila nyatakan kata laluan untuk mengakses sandaran {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Sila nyatakan kata laluan untuk mengakses arkib {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Kata laluan",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Kata laluan salah",
    "wr-dashboard.form.button.open": "Buka",
    "wr-dashboard.form.button.close": "Tutup",
    "wr-dashboard.form.button.cancel": "Batal",
    "wr-dashboard.form.button.continue": "Teruskan",
    "wr-dashboard.form.button.proceed": "Teruskan",
    "wr-dashboard.form.button.delete": "Hapus",
    "wr-dashboard.form.button.done": "Selesai",
    "wr-dashboard.form.button.retry": "Cuba semula",
    "wr-dashboard.notary.verify.view.status.downloading": "Memuat turun...",
    "wr-dashboard.notary.verify.view.status.validating": "Mengesahkan...",
    "wr-dashboard.notary.verify.view.status.pending": "Sijil belum selesai...",
    "wr-dashboard.notary.verify.view.status.fail": "Sijil tidak sepadan...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Dapatkan sijil",
    "wr-dashboard.notary.verify.view.file-info.name": "NAMA",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "DITANDATANGANI OLEH",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "TARIKH DISANDAR",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "TARIKH DIPERAKUI NOTARI",
    "wr-dashboard.notary.verify.view.button.cancel": "Batal",
    "wr-dashboard.notary.verify.view.button.done": "Selesai",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Versi pelayar tidak disokong",
    "wr-dashboard.versions-dialog-box.title": "Versi {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Hantar untuk tandatangan",
    "wr-dashboard.asign-dialog-box.message": "Versi fail dikongsi tetapi tiada sesiapa boleh melihat fail tanpa pautan padanya. Teruskan ke ASign untuk menambah penandatangan dan kongsikan pautan.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Tunjukkan Butiran fail",
    "wr-dashboard.page-not-found.title": "Halaman tidak ditemui",
    "wr-dashboard.page-not-found.message.main": "Halaman yang anda cari tidak dijumpai.",
    "wr-dashboard.page-not-found.message.description": "Pautan ini mungkin sudah lapuk, atau anda mungkin telah menaip alamat yang salah.",
    "wr-dashboard.page-not-found.message.error": "Kod ralat: 404",
    "wr-dashboard.server-error.title": "Pelayan tidak tersedia",
    "wr-dashboard.server-error.message": "Pelayan ini tidak tersedia buat masa ini. Sila cuba sebentar lagi.",
    "wr-dashboard.server-error.message.error": "Kod ralat: 500",
    "wr-dashboard.account-menu.action.sign-out": "Log keluar",
    "wr-dashboard.breadcrumb.item.machines": "Mesin",
    "wr-dashboard.breadcrumb.item.failed-backups": "Sandaran gagal",
    "wr-dashboard.machines-table.column.name": "Nama",
    "wr-dashboard.machines-table.column.size": "Saiz",
    "wr-dashboard.machines-table.message.no-machines": "Tiada mesin lagi dalam Awan",
    "wr-dashboard.incomplete-backups.message.status:plural": "Anda mempunyai {count} sandaran gagal atau tidak lengkap yang mengisi {size} storan | Anda mempunyai {count} sandaran gagal atau tidak lengkap yang mengisi {size} storan",
    "wr-dashboard.incomplete-backups.button.view": "Lihat sandaran",
    "wr-dashboard.incomplete-backups.button.delete": "Hapuskan sandaran",
    "wr-dashboard.machines-table.message.space-used:plural": "Jumlah penggunaan sandaran {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Hapuskan arkib",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Hapuskan arkib yang tidak lengkap",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Hapuskan semua arkib yang tidak lengkap",
    "wr-dashboard.delete-archive.message": "Adakah anda pasti anda ingin menghapuskan arkib yang dipilih daripada semua lokasi secara kekal? Semua data akan dihapuskan dan tidak boleh dipulihkan.",
    "wr-dashboard.delete-archive.deletion-warning-message": "Apa-apa perubahan dalam konsol pemulihan web ini mungkin tidak dapat dilihat secara visual dalam beban kerja konsol perlindungan masing-masing jika beban kerja itu tiada dalam talian, atau mana-mana ejen dalam talian untuk memproses perubahan",
    "wr-dashboard.delete-archive.locked-error-message": "Arkib telah dikunci bagi memastikan kekonsistenan data. Sila tamatkan semua operasi yang mempunyai arkib (contohnya, layari, pulihkan, sandarkan) dan cuba lagi.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Sijil belum selesai",
    "wr-dashboard.certificate-pending-dialog-box.message": "Cuba lagi dalam beberapa minit.",
    "wr-dashboard.form.button.ok": "Ok"
};
